import { useMemo, useCallback } from "react";
import type { BaseEntity, SimpleTableConfig, FieldLayout } from "../types";
import { renderCellValue } from "../../utils/cell-value-rendering";
import { resolveCardFaceFieldLayout } from "../../utils/resolve-card-face-field-layout";

interface UseCardFieldsProps<TData extends BaseEntity> {
  config: SimpleTableConfig<TData>;
  visibleColumns: string[];
}

export function useCardFields<TData extends BaseEntity>({
  config,
  visibleColumns,
}: UseCardFieldsProps<TData>) {
  const fieldLayout = useMemo((): FieldLayout => {
    return resolveCardFaceFieldLayout(config, visibleColumns);
  }, [visibleColumns, config]);

  const renderFieldValue = useCallback(
    (item: TData, fieldId: string) => {
      const value = item[fieldId as keyof TData];
      return renderCellValue(value, config.fields[fieldId], fieldId, false, {
        cardSurface: true,
        entityRecord: item as Record<string, unknown>,
        entityType: config.entity,
      });
    },
    [config]
  );

  return {
    fieldLayout,
    renderFieldValue,
  };
}
